export default "__VITE_ASSET__vqIxeCt9__"